import { createCouponActivationMutation } from '@hcr/api/consumer'

import { HTTP_CONFIG } from '../../../../configs'

export const useCouponActivationMutation = createCouponActivationMutation(HTTP_CONFIG.API.Consumer.url)
